import { setupVideoPlayerModal } from '@/modules/setupVideoPlayerModal';
import { trackStoreeelEvent } from "@/helpers/trackStoreeelEvent";
import localStorageRepositories from "@/plugins/localStorageRepositories";
import { preventFullscreen } from '@/modules/actions/preventFullscreen';

export const campaignIconsTapAction = () => {
  document.querySelectorAll('.storeeel_campaign').forEach(icon => {
    // アイコン内の動画があれば、iPhone時に全画面抑制を適用しコントロールを削除
    const videoEl = icon.querySelector('video');
    if (videoEl && window.isIphone) {
      preventFullscreen(videoEl);
      videoEl.removeAttribute('controls');
    }
    icon.addEventListener('click', handleIconClick);
  });
};

function handleIconClick(event) {
  const icon = event.currentTarget;
  const campaign = getCampaignFromIcon(icon);
  if (!campaign) return;

  // グローバル設定
  window.storeeelItems = campaign;
  window.iconId        = icon.id;
  window.moviePosition = calcMoviePosition(campaign, icon);

  // イベント計測とローカルストレージ
  recordCampaignClick(campaign);
  recordGroupClick(campaign, icon);

  // モーダル起動
  setupVideoPlayerModal();
}

// クリックしたアイコンのclassからキャンペーン情報を取得
function getCampaignFromIcon(icon) {
  const id = parseInt(icon.className.match(/campaign_(\d+)/)?.[1], 10);
  return Array.isArray(window.storeeelData)
    ? window.storeeelData.find(item => item.id === id)
    : null;
}

// クリックしたグループの位置を取得
function calcMoviePosition(campaign, icon) {
  if (campaign.frame === 'square' && !campaign.isMobile) {
    const groupId = icon.id.split('-').pop();
    return campaign.contentGroups.findIndex(g => g.id == groupId);
  }
  return 0;
}

// クリックしたキャンペーンの情報をローカルストレージに保存とイベント送信
function recordCampaignClick(campaign) {
  trackStoreeelEvent('storeeel_campaign_click', {
    storeeel_name: campaign.name,
    campaign_id:   campaign.id,
  });
  try {
    localStorageRepositories
      .get('campaignClick')
      .set(campaign.id);
  } catch (e) {
    console.warn('localStorageのcampaignClickの保存に失敗:', e);
  }
}

// クリックしたグループの情報をローカルストレージに保存とイベント送信(グループ型のみ)
function recordGroupClick(campaign, icon) {
  if (campaign.frame === 'square') return;
  const groupId = icon.id.split('-').pop();
  trackStoreeelEvent('storeeel_group_click', {
    storeeel_name: icon.getAttribute('group-name'),
    group_id:      groupId,
    campaign_id:   campaign.id,
  });
  try {
    localStorageRepositories
      .get('groupClick')
      .set(groupId, campaign.id);
  } catch (e) {
    console.warn('localStorageのgroupClickの保存に失敗:', e);
  }
}
